var map = {
	"./asset.png": 872,
	"./bells.png": 410,
	"./bnb.png": 873,
	"./btc.png": 874,
	"./calandar.png": 875,
	"./coin.png": 876,
	"./currency.png": 877,
	"./dashboard.png": 878,
	"./down.png": 879,
	"./eth.png": 880,
	"./fund.png": 881,
	"./james.png": 412,
	"./logo.png": 882,
	"./logo2.png": 413,
	"./logo3.png": 883,
	"./mail.png": 409,
	"./news.png": 884,
	"./price.png": 885,
	"./report.png": 886,
	"./settings.png": 887,
	"./social/defipulse.png": 414,
	"./social/discord.svg": 415,
	"./social/discord_white.svg": 248,
	"./social/gitbook.svg": 416,
	"./social/github.svg": 417,
	"./social/medium.svg": 418,
	"./social/telegram.svg": 419,
	"./social/twitter.svg": 420,
	"./up.png": 888,
	"./user.png": 411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;